export class InquiryModel {
    country: string;
    emailId: string;
    customerName: string;
    description: string;
    productId: String;
    productName: String;
    mobileNumber: Number;
    sku: String;
    INTsku: String;
}